import { Routes, Route } from "react-router-dom";
import Layout from "./layout/Layout";
import AuthDebugger from "./common/AuthDebugger";
import { FeatureRoute } from "./routing/FeatureRoute";
import { PromptAdminRoute } from "./routing/PromptAdminRoute";

// Page imports
import Pipeline from "../pages/pipeline/Pipeline";
import Summary from "../pages/pipeline/Summary";
import MyDashboard from "../pages/dashboard/MyDashboard";
import MyTasks from "../pages/tasks/MyTasks";
import Sponsors from "../pages/sponsors/Sponsors";
import Ndas from "../pages/ndas/Ndas";
import Contacts from "../pages/contacts/Contacts";
import Assets from "../pages/assets/Assets";
import Tenants from "../pages/tenant/Tenants";
import LoanComps from "../pages/loanComps/LoanComps";

// Create page imports
import CreateDealUpdate from "../pages/deal/CreateDealUpdate";
import CreateSponsor from "../pages/sponsors/CreateSponsor";
import CreateContact from "../pages/contacts/CreateContact";
import CreateAsset from "../pages/assets/CreateAsset";
import CreateTenant from "../pages/tenant/CreateTenant";
import CreateLoanComp from "../pages/loanComps/CreateLoanComp";
import Create from "../pages/create/Create";
import UploadComps from "../pages/comps/UploadComps";
import CreateSource from "../pages/sources/CreateSource";

// Edit page imports
import EditDeal from "../pages/deal/EditDeal";
import CreateTermSheet from "../pages/deal/CreateTermSheet";
import EditSponsor from "../pages/sponsors/EditSponsor";
import EditContact from "../pages/contacts/EditContact";
import EditAsset from "../pages/assets/EditAsset";
import EditTenant from "../pages/tenant/EditTenant";
import EditLoanComp from "../pages/loanComps/EditLoanComp";
import EditSource from "../pages/sources/EditSource";

// Wrapper imports
import SponsorWrapper from "../pages/sponsors/SponsorWrapper";
import DealWrapper from "../pages/deal/DealWrapper";
import ContactWrapper from "../pages/contacts/ContactWrapper";
import AssetWrapper from "../pages/assets/AssetWrapper";
import TenantWrapper from "../pages/tenant/TenantWrapper";
import LoanCompWrapper from "../pages/loanComps/LoanCompWrapper";
import SourceWrapper from "../pages/sources/SourceWrapper";
import AIExtractions from "../pages/extractions/AIExtractions";
import ExtractionDetail from "../pages/extractions/ExtractionDetail";
import PromptManagement from "../pages/prompts/PromptManagement";
import AddTemplatesWrapper from "../pages/addTemplates/AddTemplatesWrapper";
import Sources from "../pages/sources/Sources";
import MarketReports from "../pages/marketReports/MarketReports";
import ReportDetail from "../pages/marketReports/ReportDetail";
import Settings from "../pages/settings/Settings";
import SettingsUsers from "../pages/settings/SettingsUsers";

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Pipeline />} />
        <Route path="summary" element={<Summary />} />
        <Route path="my-dashboard" element={<MyDashboard />} />
        <Route path="my-tasks" element={<MyTasks />} />

        {/* Deal routes */}
        <Route path="create/deal" element={<CreateDealUpdate />} />
        <Route path="deals/:dealId" element={<DealWrapper />} />
        <Route path="deals/:dealId/edit" element={<EditDeal />} />
        <Route path="deals/:dealId/create-term-sheet" element={<CreateTermSheet />} />

        {/* Sponsor routes */}
        <Route path="create/sponsor" element={<CreateSponsor />} />
        <Route path="sponsors" element={<Sponsors />} />
        <Route path="sponsors/:sponsorId" element={<SponsorWrapper />} />
        <Route path="sponsors/:sponsorId/edit" element={<EditSponsor />} />

        {/* NDA register */}
        <Route path="ndas" element={<Ndas />} />

        {/* Source routes */}
        <Route path="create/source" element={<CreateSource />} />
        <Route path="sources" element={<Sources />} />
        <Route path="sources/:sourceId" element={<SourceWrapper />} />
        <Route path="sources/:sourceId/edit" element={<EditSource />} />

        {/* Contact routes */}
        <Route path="create/contact" element={<CreateContact />} />
        <Route path="contacts" element={<Contacts />} />
        <Route path="contacts/:contactId" element={<ContactWrapper />} />
        <Route path="contacts/:contactId/edit" element={<EditContact />} />

        {/* Market Reports routes */}
        <Route
          path="market-reports"
          element={
            <FeatureRoute feature="market_reports">
              <MarketReports />
            </FeatureRoute>
          }
        />
        <Route
          path="market-reports/reports/:reportId"
          element={
            <FeatureRoute feature="market_reports">
              <ReportDetail />
            </FeatureRoute>
          }
        />

        {/* Asset routes */}
        <Route path="create/asset" element={<CreateAsset />} />
        <Route path="assets" element={<Assets />} />
        <Route path="assets/:assetId" element={<AssetWrapper />} />
        <Route path="assets/:assetId/edit" element={<EditAsset />} />

        {/* Tenant routes */}
        <Route path="create/tenant" element={<CreateTenant />} />
        <Route path="tenants" element={<Tenants />} />
        <Route path="tenants/:tenantId" element={<TenantWrapper />} />
        <Route path="tenants/:tenantId/edit" element={<EditTenant />} />

        {/* Loan Comp routes */}
        <Route path="create/loan-comp" element={<CreateLoanComp />} />
        <Route path="loan-comps" element={<LoanComps />} />
        <Route path="loan-comps/:loanCompId" element={<LoanCompWrapper />} />
        <Route path="loan-comps/:loanCompId/edit" element={<EditLoanComp />} />

        {/* Other routes */}
        <Route path="upload-comps" element={<UploadComps />} />
        <Route path="create" element={<Create />} />
        <Route path="ai-extractions" element={<AIExtractions />} />
        <Route
          path="ai-extractions/:extractionId"
          element={<ExtractionDetail />}
        />
        <Route
          path="prompts"
          element={
            <PromptAdminRoute>
              <PromptManagement />
            </PromptAdminRoute>
          }
        />
        <Route path="add-templates" element={<AddTemplatesWrapper />} />
        <Route path="settings" element={<Settings />} />
        <Route path="settings/users" element={<SettingsUsers />} />
      </Route>

      {/* Auth debugging tools (clear cache / force login): dev server only, never in production builds. */}
      {import.meta.env.DEV && (
        <Route path="/debug-auth" element={<AuthDebugger />} />
      )}
    </Routes>
  );
};
